export default __webpack_public_path__ + "locales/en/ChangePortalOwner.json?hash=d14ad122be4d218cb7eaa647ac875daa";